<template>
  <div class="add-variant-to-chapter-dailog dialog col-block">
    <div class="block-container variant col-block">
      <div class="title-container">
        <div class="title">{{ 'Add a variant to chapter'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '16px' }"></div>
      <div class="variant-container col-block flex-start">
        <div class="variant-title" v-html="'<b>' + variant.SYMBOL + '</b>' + ' ' + variant.CHROM + ':' + variant.POS + variant.REF + '>' + variant.ALT"></div>
        <div :style="{ height: '10px' }"></div>
        <div class="gene-tag-container row-block flex-start flex-wrap" >
          <div class="gene-tag-block" v-for="(tag, tindex) in (variant.source || []).filter((x, i, s) => s.indexOf(x) === i)" :key="tindex">
            <div class="gene-tag" :title="geneTypeMetadatas[tag].tagOption.title" :class="[tag]">{{ geneTypeMetadatas[tag].tagOption.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '26px' }"></div>
    <div class="block-container chapter col-block">
      <div class="title-container">
        <div class="title">{{ 'Select at least one chapter'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '12px' }"></div>
      <div class="chapter-container row-block">
        <div class="chapter-list-container row-block flex-wrap">
          <div class="chapter-item-container" v-for="(chapter, index) in chapters" :key="index">
            <div class="chapter-item row-block" @click="e => selectedChapters = (selectedChapters.includes(chapter.value) ? selectedChapters.slice(index, 1) : selectedChapters.concat([chapter.value]))">
              <img :src="selectedChapters.includes(chapter.value) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')">
              <div :style="{ width: '8px' }"></div>
              <div class="chapter-title">{{ chapter.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => $emit('changeModal', {}, selectedChapters)">
        <span>{{ 'Add'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { geneTypeMetadatas } from '../../constants/global/data'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedChapters: []
    }
  },
  computed: {
    // param
    variant () {
      return this.param.variant
    },
    chapters () {
      return this.param.chapters
    },
    // global
    geneTypeMetadatas () { return geneTypeMetadatas }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/addVariantToChapter.vue